document.addEventListener("DOMContentLoaded", () => {
    let quickAddDrawer = document.querySelector('.product-grid-container');

    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(async function(m) {
                if (m.addedNodes.length) {
                    const res = await BSS_B2B.storage.productStorage.load();
                    if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                        await BSS_B2B.observer.productSubject.notifyObserver(
                            'LazyProduct',
                            'LoadedLazyProduct',
                            { ...res }
                        );
                    }
                }
            });
        });

        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

    let a = document.querySelectorAll('[bss-b2b-variant-click]');
    if (a.length) {
        a.forEach(element => {
            element.addEventListener('click', () => {
                let price = document.querySelector('[bss-b2b-product-form]');
                if (!price) return;

                price.classList.add('bss-disable');

                setTimeout(() => {
                    price.classList.remove('bss-disable');
                    const productForm = document.querySelector('[bss-b2b-product-form]');
                    if (productForm) {
                        BSS_B2B.observer.productSubject.notifyObserver(
                            'VariantChange',
                            'VariantSelectChange',
                            { productForm }
                        );
                    }
                }, 1500);
            });
        });
    }

    if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
        setTimeout(() => {
            const observer = new MutationObserver((MutationList) => {
                for (let item of MutationList) {
                    if (item.target.classList?.contains('halo-cart-content')) {
                        BSS_B2B.observer.cartSubject.listenCartCheckout();
                    }
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }, 300);
  }
});

// if (typeof BSS_B2B) {
//     setTimeout(() => {
//         const srStatus = BSS_B2B.sr.status;
//         const pickup = document.querySelector(".delivery-method .pickup");
//         const shipping = document.querySelector(".delivery-method .shipping");
//         if (pickup && shipping) {
//             if (srStatus) {
//                 pickup.removeAttribute("checked");
//                 shipping.setAttribute("checked", true);
//             } else {
//                 shipping.removeAttribute("checked");
//                 pickup.setAttribute("checked", true);
//             }
//         }

//         const radios = document.querySelectorAll('input[name="deliveryOption"]');
//         if (radios.length > 0) {
//             radios.forEach(radio => {
//                 radio.addEventListener("change", function () {
//                 BSS_B2B.sr.status = this.value === "shipping";
//                 });
//             });
//         }
//         BSS_B2B?.observer?.cartSubject?.listenCartCheckout();
//     }, 5000)
// }